module.exports = __webpack_public_path__ + "static/media/up-right-arrow.11e92363.svg";